import { useState } from 'react';
import {
  Container,
  CloseButton,
  Nav,
  NavList,
  Link,
  InternalLink,
  CTA,
} from './styled';
import {
  ROUTE_DASHBOARD,
  ROUTE_PLANS,
  ROUTE_ABOUT,
  ROUTE_WELCOME,
} from '@/constants/routes';
import { Modal } from '@simplywallst/ui-core';
import loadable from '@loadable/component';
import { useTracking } from 'react-tracking';
import If from '@/components/If';
import { Transition } from 'react-transition-group';
import useUser from '@/hooks/useUser';

const GuestRegistrationModal = loadable(
  () =>
    import(/* webpackPrefetch: true */ '@/components/GuestRegistrationModal')
);

interface Props {
  onClose?: () => void;
  show: boolean;
}

export const SideMenu = ({ show, onClose }: Props) => {
  const [showRegistration, setShowRegistration] = useState(false);
  const { trackEvent } = useTracking();
  const {
    data: { loggedIn },
  } = useUser();
  return (
    <>
      <Transition in={show} timeout={300}>
        {(status) => {
          if (status === 'exited') return null;
          return (
            <Modal isNaked removeWindowScroll onClose={onClose}>
              <Container status={status}>
                <CloseButton onClick={onClose} />
                <Nav>
                  <NavList>
                    <InternalLink to={{ type: ROUTE_ABOUT }}>
                      About us
                    </InternalLink>
                  </NavList>
                  <NavList>
                    <InternalLink to={{ type: ROUTE_PLANS }}>
                      Plans
                    </InternalLink>
                  </NavList>
                  <NavList>
                    <Link href="/careers">Careers</Link>
                  </NavList>
                </Nav>
                <If
                  conditions={{
                    loggedOut: !loggedIn,
                    loggedIn: loggedIn,
                  }}
                >
                  {{
                    loggedOut: () => (
                      <>
                        <CTA
                          styleType="louderLarge"
                          display="block"
                          onClick={() => setShowRegistration(true)}
                        >
                          Register for a Free Plan
                        </CTA>
                        <InternalLink
                          to={{ type: ROUTE_WELCOME }}
                          onClick={() => {
                            trackEvent({
                              action: 'click',
                              modifier: 'login',
                            });
                          }}
                        >
                          <CTA styleType="gentleLargeReverse" display="block">
                            Login
                          </CTA>
                        </InternalLink>
                      </>
                    ),
                    loggedIn: () => (
                      <InternalLink
                        to={{ type: ROUTE_DASHBOARD }}
                        onClick={() => {
                          trackEvent({
                            action: 'click',
                            modifier: 'dashboard',
                          });
                        }}
                      >
                        <CTA styleType="louderLarge" display="block">
                          Go to platform
                        </CTA>
                      </InternalLink>
                    ),
                  }}
                </If>
              </Container>
            </Modal>
          );
        }}
      </Transition>

      <If match={showRegistration}>
        {() => (
          <GuestRegistrationModal
            canClose
            onClose={() => setShowRegistration(false)}
            onRegisterSuccess={() => {
              trackEvent({
                type: 'track',
                subject: 'sideMenuMobile',
                modifier: 'registration',
                action: 'success',
              });
            }}
          />
        )}
      </If>
    </>
  );
};
